export const CONFIG = {
  API_URL: process.env.REACT_APP_API_URL,
  NEWS_PATH: '/api/news',
  SHOW_ITEMS_NUMBER: 9,
};
